export default "__VITE_ASSET__5kSn6bt9__"